import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ParameterTypeModel } from './parameter-types.model';

@Injectable()
export class ParameterTypesService {

    constructor(private http: HttpClient) { }

    getAll(): Promise<ParameterTypeModel[]> {
        return this.http.get<ParameterTypeModel[]>(`${environment.apiUrl}/ParameterTypes/All`).toPromise();
    }
}
